import React from 'react'
import { Link } from 'react-scroll'
import TypewriterComponent from 'typewriter-effect'
import './Home.css'
const Home = ({setShow}) => {
  return (
      <div  id='home'  className='homecont'>
        <div className='icons-container'>
          <div className='icons'>
            <li><a href='https://github.com/Likhith329' target={'_blank'}><i className='bi bi-github text-secondary' style={{fontSize:'25px'}}></i></a></li>
            <li><a href='https://www.linkedin.com/in/likhith-mattapalli-b2a698219' target={'_blank'}><i className='bi bi-linkedin text-secondary' style={{fontSize:'25px'}}></i></a></li>
            <li><a href='#contact' ><i className='bi bi-envelope text-secondary' style={{fontSize:'25px'}}></i></a></li>
          </div>
        </div>
        <div className='email-container'>
          <p style={{margin:'0'}}>likhithmattapalli@gmail.com</p>
        </div>
        <main>
          <p className='hi_name'>Hi, my name is</p>
          <h1 >Likhith kumar Mattapalli</h1>
          <h2>
            <TypewriterComponent
            options={{
              autoStart:true,
              loop:true,
              delay:50,
              strings:["I build things for the web.","I am a full-stack developer."]
            }}            
            />
          </h2>
          <p className='detail'>
          I’m a Software Engineer and Full-Stack Developer with expertise in building scalable web applications and interactive solutions. Known for strong problem-solving skills, I’m passionate about creating high-performance, user-friendly experiences that drive real impact.
          </p>
          <Link to='about' spy={true} smooth={true} offset={-50} duration={50}><button className='bg-transparent' onClick={()=>{setShow('')}} >Check out More</button></Link>
        </main>
      </div>
  )
}

export default Home